import { render, staticRenderFns } from "./feedbackTpl.vue?vue&type=template&id=7851ec7a&"
import script from "./feedbackTpl.vue?vue&type=script&lang=js&"
export * from "./feedbackTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports